/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const borderColor = '#00519C';

// ✅ SAME COLUMN WIDTHS (shared logic)
const columnStyles = {
	id: { width: '5%', textAlign: 'center',height:'100%' },
	name: { width: '15%', textAlign: 'left',height:'100%' },
	region: { width: '10%', textAlign: 'left',height:'100%' },
	pids: { width: '10%', textAlign: 'left',height:'100%' },
	channel: { width: '10%', textAlign: 'left',height:'100%' },
	type: { width: '8%', textAlign: 'center',height:'100%' },
	date: { width: '12%', textAlign: 'center',height:'100%' },
	chainage: { width: '10%', textAlign: 'center',height:'100%' },
	gps: { width: '10%', textAlign: 'left',height:'100%' },
	user: { width: '10%', textAlign: 'left' ,height:'100%'},
	status: { width: '10%', textAlign: 'center',height:'100%' }
};

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		backgroundColor: '#00519C',
		color: '#fff',
		height: 24,
		alignItems: 'center',
	},

	headerCell: {
		fontSize: 10,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
		padding: 4,
	},
});

const paginate = (array, perPage) => {
	const pages = [];
	for (let i = 0; i < array.length; i += perPage)
		pages.push(array.slice(i, i + perPage));
	return pages;
};

const InvoiceItemsTable = (props) => {
	const itemsPerPage = 10;
	const pages = paginate(props.invoice, itemsPerPage);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<React.Fragment key={pageIndex}>

					{pageIndex > 0 && <View break />}

					<View wrap={true}>
						{/* ✅ HEADER */}
						<View style={styles.container}>
							<Text style={[styles.headerCell, columnStyles.id]}>Id</Text>
							<Text style={[styles.headerCell, columnStyles.name]}>Name</Text>
							<Text style={[styles.headerCell, columnStyles.region]}>Region</Text>
							<Text style={[styles.headerCell, columnStyles.pids]}>PIDS</Text>
							<Text style={[styles.headerCell, columnStyles.channel]}>Channel</Text>
							<Text style={[styles.headerCell, columnStyles.type]}>Type</Text>
							<Text style={[styles.headerCell, columnStyles.date]}>Date</Text>
							<Text style={[styles.headerCell, columnStyles.chainage]}>Chainage</Text>
							<Text style={[styles.headerCell, columnStyles.gps]}>GPS</Text>
							<Text style={[styles.headerCell, columnStyles.user]}>User</Text>
							<Text style={[styles.headerCell, columnStyles.status]}>Status</Text>
						</View>

						{/* ROWS */}
						<InvoiceTableRow data={pageData} columnStyles={columnStyles} />
					</View>

				</React.Fragment>
			))}
		</>
	);
};

export default InvoiceItemsTable;